import React, { useState, useEffect } from "react";
import { useStateContext } from "../contexts/ContextProvider";
import ResultCard from "../components/ResultCard/ResultCard";
import { useParams, useNavigate } from "react-router-dom";
import PopUp from "../components/PopUp/PopUp";
import Countdown from "react-countdown";
import axios from "axios";
import Footer from "../components/Footer/Footer";

import MobileBanner from "../components/NativeBanner/MobileBanner";
import DesktopBanner from "../components/NativeBanner/DesktopBanner";

const Final = (props) => {
  const navigate = useNavigate();
  const { contestId } = useParams();
  const [ads, setAds] = useState(null);
  const { songs, loading, getSongs } = useStateContext();
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(true);

  const Completionist = () => <span>00:00:00:00</span>;

  const getAds = () => {
    try {
      axios
        .get(
          `${process.env.REACT_APP_BACKEND_API_SERVER}/ads-by-contest/${contestId}`
        )
        .then(
          (response) => {
            console.log(response.data["ads"]);
            setAds(response.data["ads"][0]);
          },
          (error) => {
            alert(error);
          }
        );
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    if (!window.matchMedia("(max-width: 688px)").matches) {
      setIsMobile(false);
    }
    getSongs(contestId);
    getAds();
    setTimeout(() => {
      setShowModal(true);
    }, 1800);
  }, [contestId]);

  if (loading || songs.length === 0) return <p>Loading...</p>;

  if (songs.length > 0) {
    console.log(songs);
    let result = new Date(songs[0].roundStartAt);
    result.setDate(result.getDate() + 3);

    const songResult = songs.map((song) => (
      <ResultCard
        page="final"
        key={song.id}
        url={song.songLink}
        title={song.title}
        artist={song.artist}
        imgLink={song.imgLink}
        buttonVisible={true}
        percentage={song.percentage}
      />
    ));

    return (
      <>
        {isMobile ? <MobileBanner /> : <DesktopBanner />}
        <div className="flex-row">
          <div className="flex w-full justify-center">
            <button
              onClick={() => {
                navigate("/");
              }}
              className="text-md font-bold text-white p-6 sm:mt-3 mt-6 mb-3"
            >
              You've finished voting in {songs[1].round}!
              <p className="mt-1.5">
                {songs[1].round !== "Round 3"
                  ? "The next round will start in "
                  : "The contest will end in "}
                <Countdown date={result}>
                  <Completionist />
                </Countdown>
              </p>
            </button>
          </div>
          <div
            className={
              songResult.length > 2
                ? "grid lg:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 lg:grid-rows-2 gap-x-3"
                : "grid sm:grid-cols-2 grid-cols-1 lg:grid-rows-2 gap-x-3"
            }
          >
            {songResult}
          </div>
          {/* Ads Pop Up */}
          {showModal && ads ? (
            <PopUp data={ads} setShowModal={setShowModal} />
          ) : null}
        </div>
        <Footer />
      </>
    );
  }
};

export default Final;
